// extracted by mini-css-extract-plugin
export var nav = "Navigation-module--nav--MHlRW";
export var current = "Navigation-module--current--gund2";
export var button = "Navigation-module--button--r5CVT";
export var close = "Navigation-module--close--ihsP4";
export var subnav = "Navigation-module--subnav--y2bJq";
export var wrapper = "Navigation-module--wrapper--e3qhQ";
export var hasSubnav = "Navigation-module--hasSubnav--hX1n5";